export default {
    data() {
        return {
            credits: []
        }
    },
    created() {
        this.credits = this.getCreditsList()
    },
    methods: {
        getCreditsList() {
            return [
                {
                    name: 'Carleen Anderson',
                    img: 'images/bios/Carleen_Anderson.png',
                    category: 'Performer',
                    url: 'http://www.cagestreetmemorial.com',
                    bio: 'Known globally for her collaboration with the 1991 Mercury Music Award Shortlisted Young Disciples for their album, Road to Freedom and her 1994 Brit Award nominated solo album TRUE SPIRIT, Carleen won Jazz FM’s 2013 Best UK Vocalist Award. She received exceptional praise for her CAGE STREET MEMORIAL Tribal Opera concert at the Barbican in January 2018.'
                },
                {
                    name: 'Shazz Andrew',
                    img: 'images/bios/Shazz_Andrew.jpg',
                    category: 'Performer',
                    url: 'https://www.cornwallmeditationcentre.com',
                    bio: 'Shazz has worked with Kneehigh, Wildworks, Perthi Kov, Plebeian, Cambridge Shakespeare Festival, The Minack, The Society of Wonders, Cornwall Youth Theatre & Hall for Cornwall Youth Theatre and Minack Youth Theatre, Signs and Wonders, BBC, ITV and Channel 4 & many times with SLG! Shazz is director of Cornwall Meditation Centre & a Teacher of Vedic Meditation.'
                },
                {
                    name: 'Bec Applebee',
                    img: 'images/bios/Bec_Applebee.jpg',
                    category: 'Performer',
                    url: 'http://becapplebee.com',
                    bio: 'Bec has worked with Kneehigh, Wildworks and at the Minack Theatre and as a performance director for Incandescence circus & mentor Rogue theatre as a singer and percussionist Bec played with Dalla for 18 years producing 5 albums. She plays with Didjan, the Nos Lowen band Skillywidden and also represents Cornwall singing in Cornish with the fabulous Tosta.'
                },
                {
                    name: 'Lyn Barlow',
                    img: 'images/bios/Lyn_Barlow.jpg',
                    category: 'Writer',
                    url: '',
                    bio: "Born 1963 in Sheffield. Lived at Greenham Yellow Gate 1983-1984. Worked at New Statesman then returned to higher education, New Hall, Cambridge. Now textile artist living in Somerset"
                },
                {
                    name: 'Becky Barry',
                    img: 'images/bios/Becky_Barry.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: "Becky is a theatre maker & BSL/English interpreter (Becky Allen RSLI). She is passionate about accessibility, representation and equality - onstage and off. She has worked extensively across the UK and abroad, including collaborations with Shakespeare’s Globe, The RSC and Derby Theatre. She was also delighted to mentor two members of Graeae's Ensemble."
                },
                {
                    name: 'Alison Belbin',
                    img: 'images/bios/Alison_Belbin.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Alison is an actor, director, writer/deviser & drama worker, who has worked with Women & Theatre, Other Way Works, Red Ladder, Foursight,  Hearth, Pentabus & Birmingham Rep.  She has been in many radio plays,  including  ‘Mill on the Floss’ & The Archers, & won the Norman Beaton Fellowship in 2016.  TV includes ‘Emmerdale’, ‘The Cure’,  ‘Switch’ & ‘Doctors’.'
                },
                {
                    name: 'Roisin Bermingham',
                    img: 'images/bios/Roisin_Bermingham.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'Roisin Bermingham lives in Cornwall. She is a member of the Minack Youth Theatre where she has has perfomed in productions including Good Night Mr Tom, The Railway Children, as Dickon in The Secret Garden and with Scary Little Girls in Before I Wake. She is due to perform as Hetty Feather in the up and coming Minack Theatre production of Hetty Feather. '
                },
                {
                    name: 'Lladel Bryant',
                    img: 'images/bios/Lladel_Bryant.jpeg',
                    category: 'Performer',
                    url: 'http://lladelbryant.com',
                    bio: 'Lladel is an experienced actor who has also recently embarked on a journey of creative social change. Through his impromptu #freestylemonologues which he produces and shares online. He aims to use his experience as an actor and certified speaker to Entertaining, Educating & Empower young people aged 13-18, to strive for greatness in all areas of their lives. '
                },
                {
                    name: 'Kudzanayi Chiwawa',
                    img: 'images/bios/Kudzanayi_Chiwawa.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'Trained at Drama Studio London, worked in theatre internationally, represented by Narrow Road Company '
                },
                {
                    name: 'Chloë Clarke',
                    img: 'images/bios/Chloe_Clarke.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Chloë is an Audio Description Consultant, Actor/Musician and Director based in Cardiff where she co-founded Elbow Room Theatre Company. She received 2 Unlimited Commissions culminating in a 2018 tour of The Importance of Being Described...Earnestly? and the development of her own unique style of integrated audio description that she calls ‘stealth AD’.'
                },
                {
                    name: 'Jenny & Flo Crowe',
                    img: 'images/bios/Jenny_Flo_Crowe.JPG',
                    category: 'Performer',
                    url: '',
                    bio: 'Jenny and Flo Crowe are a mother and daughter from Cornwall.  Jenny’s impressive career as an actor and musician has seen her working with all the companies that make Cornwall’s performance world reknown, including Kneehigh, The Eden Project and Hall for Cornwall.  Flo is fast following in her footsteps with leads at The Minack, Heligan Gardens and with SLG.'
                },
                {
                    name: 'Elka de Wit',
                    img: 'images/bios/Elka_de_Wit.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Elka de Wit is an actor and writer based in Stoke Newington. She has trained for many years as a long form improvisor with an emphasis on social themes. She was a long term member of Flu'
                },
                {
                    name: 'Emily Faulkner',
                    img: 'images/bios/Emily_Faulkner.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'Emily began her journey performing and training with Rogue Theatre where her passion for outdoor, site specific theatre was born. Recent acting credits include Operation Neptune at Trebah Gardens 2019 and The Mousehole Cat with Cousin Jack’s, where she was lucky enough to perform on their America tour before bringing it home to Mousehole, Christmas 2019.'
                },
                {
                    name: 'Carolyn Francis',
                    img: 'images/bios/Carolyn_Francis.jpg',
                    category: 'Soundscape',
                    url: 'http://www.striding-edge.org',
                    bio: 'Carolyn is a well known for her research, performance and teaching of Cumbrian fiddle and border bagpipe tunes. She has played with Lakeland Roots band “Striding Edge” since 1996 and formed Community Band “Lakeland Fiddlers’ in 2000. She has built her musical career based on the practice of Nichiren Buddhism  which she first encountered at Greenham in 1984.'
                },
                {
                    name: 'John Gorick',
                    img: 'images/bios/John_Gorick.jpg',
                    category: 'Performer',
                    url: '',
                    bio: "John's TV credits include a stint on Holby City and, in theatre, a national tour and West End production of The Trials of Oscar Wilde, in the title role. He has perfomed widely on the Improv circuit and is a fluent Japanese speaker. He is a regular collaborator with SLG."
                },
                {
                    name: 'Kayleigh Hilsdon',
                    img: 'images/bios/Kayleigh_Hilsdon.jpg',
                    category: 'Illustrator',
                    url: 'https://scarylittlegirls.co.uk/campfire/',
                    bio: "Kayleigh graduated from Camberwell College of Art and as well as creating the beautiful illustrations you’ll see throughout this site, has illustrated our Twine based choose your own story game."
                },
                {
                    name: 'TJ Holmes',
                    img: 'images/bios/TJ_Holmes.jpg',
                    category: 'Performer',
                    url: 'https://www.spotlight.com/interactive/cv/1252-3496-0766',
                    bio: 'TJ is a performer, musician, composer and writer, and has appeared in shows by Shakespeare’s Globe, Sally Cookson, Red Ladder, Graeae, Queens Theatre and Derby Playhouse. TJ has enjoyed collaborating on stage and behind the scenes with Scary Little Girls and, during lockdown, has been inspired by being involved with the Greenham Women Everywhere project.'
                },
                {
                    name: 'Rebecca Hulbert',
                    img: 'images/bios/Rebecca_Hulbert.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'Rebecca trained for 3 years in Acting at The Royal Welsh College of Music and Drama and has since worked extensively in theatre, film, television and radio. She worked in Costa Rica and India for the charity Raleigh International. She sings with the all women sea shanty band, Femmes de la Mer, and has created the campaign www.languagecreatesreality.com'
                },
                {
                    name: 'Tracy Kearney',
                    img: 'images/bios/Tracy_Kearney.jpg',
                    category: 'Performer',
                    url: '',
                    bio: "Tracy is a London based actor from Co.Cork. Work includes The Long Run (Sky TV), Divorcing God? (Drayton Arms) The Sacred Sow (Prague Playhouse), The Ladies Cage & The Six Days World (Finborough), Talking with Angel's (Yousaf Ali Khan), Doctors (BBC), Green Green Grass (BBC), The Welcome Committee (Dogma Films) Death of Faith (BBC Radio 4)."
                },
                {
                    name: 'Mercedes Kemp',
                    img: 'images/bios/Mercedes_Kemp.png',
                    category: 'Writer',
                    url: '',
                    bio: "Mercedes Kemp is a WildWorks founding artist with specialty in community and research and a senior lecturer in Fine Art at Falmouth University. Mercedes was born and grew up in Southern Spain. For the past thirty years she has lived in West Cornwall."
                },
                {
                    name: 'Christina Li',
                    img: 'images/bios/Christina_Li.jpg',
                    category: 'Performer',
                    url: 'https://www.christinaxli.com',
                    bio: 'Christina Li is a San Francisco musician and songwriter. With songs created in response to personal experiences as a woman in an ever-changing world, Li’s music is cut-to-the-bone intimate yet pulses with energy. Li’s been releasing music since 2007 after cutting her teeth in the Bay Area singer-songwriter community and has new work out in 2020.'
                },
                {
                    name: 'Illona Linthwaite',
                    img: 'images/bios/Illona_Linthwaite.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'For Illona the C21st has meant working with inspirational new companies: Oblique House, SLG, Lost Watch, Paper Birds, Dot Collective, First Draft, Bedouin Shakespeare, Punch Drunk. During lockdown, Arts Uplift & Swamp Motel. On Zoom. Festivals include Vaults, Bedouin Shakespeare, Salzburg, Edinburgh. All dominated by women. Hurray for Age and Greenham!'
                },
                {
                    name: 'Josephine Liptrott',
                    img: 'images/bios/Josephine_Liptrott.jpg',
                    category: 'Performer',
                    url: 'http://www.josephineliptrott.co.uk',
                    bio: 'Josephine is an actor and writer who went to drama school at 40 and now earns her living in a manner far more in keeping with her skill set. She has lived on both sides of the Pennines but currently resides in West London. A long-time feminist campaigner, she hopes the dismantling of the patriarchy will happen soon so that she can put her feet up.'
                },
                {
                    name: 'Juliet Margetts',
                    img: 'images/bios/Juliet_Margetts.jpg',
                    category: 'Writer',
                    url: 'https://toilandtroubletheatrecompany.com',
                    bio: 'Juliet moved from being a Documentary Producer to a Playwright as her focus changed from fact to fiction. She enjoys bringing characters to life exploring themes of empathy, equality and the power to change ourselves and the world. She is co-founder of Toil and Trouble Theatre Company whose production “Hidden” had a sold out run at the Vaults Festival 2020.'
                },
                {
                    name: 'Rebecca Mordan',
                    img: 'images/bios/Rebecca_Mordan.JPG',
                    category: 'Performer',
                    url: '',
                    bio: 'After graduating from Bristol Old Vic and working in film, theatre and television, Rebecca created award-winning production hub Scary Little Girls, populating stories with diverse female characters. She is a founder member of Greenham Women Everywhere and a grassroots campaigner against male violence, frequently guesting on BBC Radio and Sky News.'
                },
                {
                    name: 'Tanya Myers',
                    img: 'images/bios/Tanya_Myers.jpg',
                    category: 'Performer',
                    url: 'http://www.meetinggroundtheatrecompany.co.uk',
                    bio: 'Tanya Myers is a feminist theatre maker, social activist, audio artist and playwright. TV, Film and Theatre actress; Her theatre company Meeting Ground Theatre frequently collaborates in European. She was one of the 6 devisors of The Fence performed at Greenham Common Published by Methuen 1984. '
                },
                {
                    name: 'Caroline Parker',
                    img: 'images/bios/Caroline_Parker.jpg',
                    category: 'Performer',
                    url: 'https://www.simplesite.com/carosparks',
                    bio: 'Caroline Parker actress, comedienne, cabaret performer has been signing songs since the last millennium. Songs like queen’s Bohemian Rhapsody at cabaret and festivals like Glastonbury and WOMAD. She signed the finale song at 2012 Paralympic Opening Ceremony.'
                },
                {
                    name: 'Maggie Parks OBE',
                    img: 'images/bios/Maggie_Parks.jpg',
                    category: 'Writer',
                    url: '',
                    bio: 'At 30 Maggie went to live at Greenham Common before carrying Greenham home to organise women’s groups & conferences, co-founding Worcester Rape Crisis Centre & the Women’s Rape & Sexual Abuse Centre Cornwall & was Chief Executive of Women’s Centre Cornwall for 22 years. She remains a feminist activist & believes that empowered women will change the world.'
                },
                {
                    name: 'Penny Rackett',
                    img: 'images/bios/Penny_Rackett.png',
                    category: 'Writer',
                    url: '',
                    bio: 'Situation wanted: Unsuccessful political playwright - my disappointment has though been compensated by job variety (not money), manual (labour ward assistant) interesting (blacksmith) worthwhile (political education worker) rubbishy (egg factory maggot remover). Willing to attempt almost anything (with a net), ranting at tories (real or virtual) a speciality - no issue too small. All offers considered.'
                },
                {
                    name: 'Fi Read',
                    img: 'images/bios/Fi_Read.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Born in NZ, raised in Australia, Fi set off to see the world in 1987. Intending to visit Greenham on her travels, she stayed for 3 months - a time that helped shape her feminism and activism. Based in Penzance, Fi recently retrained as a nurse. She’s crewing on a boat to the Canaries, and possibly beyond, hoping to reignite her love of words and freedom.'
                },
                {
                    name: 'Sue Say',
                    img: 'images/bios/Sue_Say.jpg',
                    category: 'Writer',
                    url: 'https://www.instagram.com/dragon.twin',
                    bio: "Greenham womon, mother, Great grandmother, political activist and campaigner, mental health advocate, childrens play organiser, amateur photographer, english tutor and more recently writer of a book 'The Missing Piece', about my life as a mixed race child, fostered by two amazing white christians and brought up in a small woodland villiage in the late 60's."
                },
                {
                    name: 'Rone Stephens',
                    img: 'images/bios/Rone_Stephens.jpg',
                    category: 'Performer',
                    url: 'https://www.nutrifitnessuk.com',
                    bio: 'Rone Stephens trained as a Singer, dancer and Actress in her teens and went on to have a varied career in musicals, pop videos and tv for 20years. After starting a family, touring became less attractive, so Rone retrained as a Personal trainer and Nutritionist. She now runs her own Fitness and Nutrition business-‘Nutrifitnessuk.com’.'
                },
                {
                    name: 'Terina Talbot',
                    img: 'images/bios/Terina_Talbot.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Terina has worked as a drama /theatre practitioner for over 35 years mainly in the field of Applied Theatre working with diverse communities outside of a traditional Theatre setting. Currently Terina is employed as a lecturer in Applied Theatre at the Birmingham Royal Conservatoire and is also a trainee Psychotherapist. She has four children.'
                },
                {
                    name: 'Gilly Tompkins',
                    img: 'images/bios/Gilly_Tomkins.jpeg',
                    category: 'Performer',
                    url: 'https://www.gossip4good.com',
                    bio: 'Gilly studied BAHons Theatre Arts at Bretton Hall and for the next decade worked with John Godber at Hull Truck. Godber wrote 9 plays for her which toured nationally, two in London’s West End. She is writing a one woman show based on “The Adventures of Mrs. Pepperpot.” Gilly is also a Life Coach and founder of Gossip4Good.'
                },
                {
                    name: 'Deborah Tracey',
                    img: 'images/bios/Deborah_Tracey.jpg',
                    category: 'Performer',
                    url: '',
                    bio: "Deborah’s work includes A Mad World My Masters (RSC), Standing At The Sky's Edge (Crucible/National Theatre) and United Queendom (Les Enfants Terribles). Screen includes: Doctors & Fee Fi Fo...Yum (BBC), Absolutely Fabulous (Fox Searchlight) & Patient Zero (Sony Pictures) & her own stage shows, Death of a Beauty Saleswoman & Fades, Braids & Keeping it Real."
                },
                {
                    name: 'Kathy Trevelyan',
                    img: 'images/bios/Kathy_Trevelyan.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Kathy is an actor, writer and tour guide who lives in London. She has five grandchildren and three cats. Going to Greenham was a formative experience that she treasures as an important part of the ongoing struggle for peace and justice in the world.'
                },
                {
                    name: 'Faye Wilson',
                    img: 'images/bios/Faye_Wilson.jpg',
                    category: 'Performer',
                    url: '',
                    bio: 'Faye Wilson is an interdisciplinary artist and theatre maker. Previous acting credits include Emmerdale, New Labour (Dir. Richard Wilson) The Castle (Dir. Philip Franks) The Importance of being Earnest (Dir. Nona Sheppard) and Holding The Man (Dir. Gene David Kirke).'
                },
                {
                    name: 'Michelle Witthaus',
                    img: 'images/bios/Michele_Witthaus.jpg',
                    category: 'Writer',
                    url: '',
                    bio: 'Michele Witthaus has a journalistic background and her writing draws on a wide range of influences, from social justice to the natural world. Her first poetry collection, ‘From a Sheltered Place’, was published in August 2020 by Wild Pressed Books. Her work has also appeared in a variety of anthologies and other publications.'
                },
                {
                    name: 'Mary Woodvine',
                    img: 'images/bios/Mary_Woodvine.jpeg',
                    category: 'Performer',
                    url: '',
                    bio: 'Mary has worked in theatre, television and film, from village halls to the National Theatre and the RSC with Kneehigh Theatre, on cliffs and gardens with Wildworks, and Minack Theatre with Scary Little Girls amongst others. TV includes: Judge John Deed, Eastenders, and Jerry Anderson’s Space Precinct. Last year she appeared in the BAFTA winning film BAIT.'
                }
            ]
        }
    }
}
